import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface RaceTableCaptionPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceTableCaption = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.small};
        `;
    }
    return css`
        border-color: ${theme.star.raceSummary.borderColor};
        border-style: solid;
        border-width: 0 0 1px 0;
    `;
};
/* Ante post and specials for now */
export const RaceTableCaption = withConfig(theme => styled('li', { label: 'RaceTableCaption' })<RaceTableCaptionPropsType>`
    ${({ variant }): SerializedStyles => setRaceTableCaption(variant, theme)}
    background: ${theme.star.raceSummary.bgColorSecondary};
    color: ${theme.star.raceSummary.txtColorTertiary};
    display: flex;
    flex-flow: row nowrap;
    font-size: ${theme.star.fontSize.xSmall};
    height: 20px;
    justify-content: space-between;
    line-height: 1.4;
    @media ${theme.star.mediaQuery.tablet} {
        border-width: 0 1px 1px 1px;
    }
`);

interface RaceSummaryCaptionHeaderPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceSummaryCaptionHeader = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.small};
            gap: ${theme.star.gap.small};
            padding-right: ${theme.star.padding.small};
        `;
    }
    return css`
        border-color: ${theme.star.raceSummary.borderColor};
        border-style: solid;
        border-width: 1px 0;
    `;
};

export const PriceBoostListWrapper = styled('ul', { label: 'PriceBoostListWrapper' })`
    margin-bottom: -1px;
`;

export const RaceSummaryCaptionHeader = withConfig(theme => styled('li', { label: 'RaceSummaryCaptionHeader' })<RaceSummaryCaptionHeaderPropsType>`
    ${({ variant }): SerializedStyles => setRaceSummaryCaptionHeader(variant, theme)}
    background: ${theme.star.raceSummary.bgColorSecondary};
    color: ${theme.star.raceSummary.txtColorTertiary};
    display: flex;
    flex-flow: row nowrap;
    font-size: ${theme.star.fontSize.xSmall};
    height: 24px;
    justify-content: space-between;
    line-height: 1.4;
    @media ${theme.star.mediaQuery.tablet} {
        border-width: 1px 0 1px 1px;
    }
`);

export const RaceSummaryCaptionHeaderCast = withConfig(theme => styled(RaceSummaryCaptionHeader, { label: 'RaceSummaryCaptionHeaderCast' })`
    height: 30px;
    @media ${theme.star.mediaQuery.tablet} {
        height: 24px;
    }
`);

export const RunnerCaptionAntePost = withConfig(theme => styled('div', { label: 'RunnerCaptionAntePost' })`
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.xMedium};
    justify-content: start;
    line-height: 1.2;
    padding: 4px 8px;
`);

interface SelectionAntePostSpecialPropsType {
    variant: DefaultComponentVariantType | null;
}

const setSelectionAntePostSpecial = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin-right: 4px;
        `;
    }
    return css`
        border-left: 1px solid ${theme.star.raceSummary.borderColor};
    `;
};

export const SelectionAntePostSpecial = withConfig(theme => styled('div', { label: 'SelectionAntePostSpecial' })<SelectionAntePostSpecialPropsType>`
    ${({ variant }): SerializedStyles=> setSelectionAntePostSpecial(variant, theme)};
    align-items: center;
    display: flex;
    flex: 0 0 48px;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.xMedium};
    line-height: 1.2;
    justify-content: center;
    padding: 4px 8px;
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 64px;
    }
`);
